<template>
  <div id="resetPassword">

    <div class="header">
      <svgicon src="svg/logo.svg" v-if="!$store.state.cogir" :width="200" :height="150"></svgicon>
      <div class="logo-container" v-if="$store.state.cogir">
        <img class="logo" src="@/assets/img/logo-cogir.png">
      </div>
    </div>

    <div class="middle">
      <div class="container">
        <div class="title">{{$t('reset_password.title')}}</div>
        <label for="txtResetPassword">{{$t('reset_password.new_password')}}</label>
        <input id="txtResetPassword" type="password" v-model="password">
        <label for="txtResetPasswordConfirmation">{{$t('reset_password.new_password_confirmation')}}</label>
        <input id="txtResetPasswordConfirmation" type="password" v-model="passwordRepeated">
        <button type="submit" class="btn btn-primary" @click="submitNewPassword">{{$t('save')}}</button>
      </div>
    </div>

    <div class="info-footer">
      <div class="locale">
        <span :class="{active: $ts.state.locale == 'fr'}" @click="setLocale('fr')">Français</span>
        <span :class="{active: $ts.state.locale == 'en'}" @click="setLocale('en')">English</span>
      </div>
      <div class="copyright" >© 2020 {{$store.state.cogir ? 'Octopus' : 'Humaniti'}}. All Rights Reserved.</div>
    </div>

    <Modal
      name="password-validation-error"
      :title="$t('error')"
      :actions="[{name: $t('back'), action: 'close'}]">
      {{ validationErrorMessage }}
    </Modal>

    <Modal
      name="server-error"
      :title="$t('oops')"
      :actions="[{name: $t('back'), action: 'close'}]">
      {{ serverErrorMessage }}
    </Modal>

  </div>
</template>

<script>
  import User from "../../core/User";
  import Configuration from '../../core/Configuration';
  import moment from "moment";

  export default {

    name: "ResetPassword",

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: false,
        showHeaderLeft: false,
        showFooter: false,
      });
    },

    data() {
      return {
        password: "",
        passwordRepeated: "",
        validationErrorMessage: "",
        serverErrorMessage: ""
      }
    },

    methods: {
      async submitNewPassword() {
        let token = this.$route.query.token;
        if (this.password === "") {
          this.validationErrorMessage = this.$t("errors.password_is_empty");
          this.$modal.show("password-validation-error");
          return;
        }
        if (this.password !== this.passwordRepeated) {
          this.validationErrorMessage = this.$t("errors.repeated_password_is_different");
          this.$modal.show("password-validation-error");
          return;
        }

        showSpinner();
        let response = await User.resetWithToken(token, this.password);
        hideSpinner();
        if (!response) {
          this.serverErrorMessage = this.$t("errors.reset_password_token_not_found_or_expired");
          this.$modal.show("server-error");
        } else {
          this.$router.push("/welcome");
        }
      },

      setLocale(locale) {
        this.$ts.commit("setLocale", locale);
        Configuration.write("locale", locale);
        moment.locale(this.locale);
      }
    }
  };

</script>

<style lang="scss" scoped>

  #resetPassword {
    display: flex;
    flex-direction: column;
    padding: 0;
    height: 100%;
    background-color: #f2f3f4 !important;
  }

  .middle {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .tooltip {
      cursor: pointer;
    }
  }

  label {
    text-transform: initial;
    margin-left: 0;
  }

  #resetPassword input {
    padding: 10px 15px;
  }

  input[type=password] + label {
    top: initial;
  }

  .container {
    background-color: white;
    padding: 40px;
    border-radius: 4px;
    width: 420px;
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 4px;
    margin-bottom: 20px;
  }

  label {
    font-size: 16px;
  }

  input {
    margin-top: 6px;
    margin-bottom: 20px;
  }

  .info-footer {
    text-align: center;
    font-size: 14px;
    color: #888;
    margin-bottom: 10px;
  }

  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }

  .locale {
    margin-bottom: 4px;

    span:first-child {
      margin-right: 5px;
    }

    .active {
      font-weight: bold;
    }
  }

</style>
